import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ComponentRef,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { ConnectorOptionComponent } from "../connector-option/connector-option.component";

@Component({
  selector: "app-delete-connector-option",
  templateUrl: "./delete-connector-option.component.html",
  styleUrls: ["./delete-connector-option.component.scss"],
})
export class DeleteConnectorOptionComponent implements OnInit {
  @Input() data!: any;
  @Input() mode: any;
  @Input() connectorOptionComponent!: ComponentRef<ConnectorOptionComponent>;
  @Output() onDeleteConnector = new EventEmitter<{
    connectorData: any;
    connectorOptionComponent: ComponentRef<ConnectorOptionComponent>;
  }>();
  private onComponentDestroy = new Subject();
  constructor(public element: ElementRef, private MatDialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  deleteConnector() {
    this.MatDialog.open(AreYouSureDialogComponent, {
      data: {
        areYouSureInfo: {
          description: `You are about to delete the link between nodes.`,
          warning: "Warning: this is not reversible!",
        },
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        if (res) {
          this.onDeleteConnector.emit({
            connectorData: this.data,
            connectorOptionComponent: this.connectorOptionComponent,
          });
        }
      });
  }
}
